"use strict";


import {  EventSource  } from 'generics/utils';

const ApplicationEvents = new EventSource();
export default ApplicationEvents;

